export default __webpack_public_path__ + "static/media/pmsBG.3e76dd6b.svg";